export const anyKeys = [
  "#00951400",
  "#00951401",
  "#00951402",
  "#00951403",
  "#00951404",
  "#00951405",
  "#00951406",
  "#00951407",
  "#00951408",
  "#00951409",
  "#0095140A",
  "#0095140B",
  "#0095140C",
  "#0095140D",
  "#0095140E",
  "#0095140F",
  "#00951410",
  "#00951411",
  "#00951412",
  "#00951413",
  "#00951414",
  "#00951415",
  "#00951416",
  "#00951417",
  "#00951418",
  "#00951419",
  "#0095141A",
  "#0095141B",
  "#0095141C",
  "#0095141D",
  "#0095141E",
  "#0095141F",
  "#00951420",
  "#00951421",
  "#00951422",
  "#00951423",
  "#00951424",
  "#00951425",
  "#00951426",
  "#00951427",
  "#00951428",
  "#00951429",
  "#0095142A",
  "#0095142B",
  "#0095142C",
  "#0095142D",
  "#0095142E",
  "#0095142F",
  "#00951430",
  "#00951431",
  "#00951432",
  "#00951433",
  "#00951434",
  "#00951435",
  "#00951436",
  "#00951437",
  "#00951438",
  "#00951439",
  "#0095143A",
  "#0095143B",
  "#0095143C",
  "#0095143D",
  "#0095143E",
  "#0095143F",
  "#00951440",
  "#00951441",
  "#00951442",
  "#00951443",
  "#00951444",
  "#00951445",
  "#00951446",
  "#00951447",
  "#00951448",
  "#00951449",
  "#0095144A",
  "#0095144B",
  "#0095144C",
  "#0095144D",
  "#0095144E",
  "#0095144F",
  "#00951450",
  "#00951451",
  "#00951452",
  "#00951453",
  "#00951454",
  "#00951455",
  "#00951456",
  "#00951457",
  "#00951458",
  "#00951459",
  "#0095145A",
  "#0095145B",
  "#0095145C",
  "#0095145D",
  "#0095145E",
  "#0095145F",
  "#00951460",
  "#00951461",
  "#00951462",
  "#00951463",
  "#00951464",
  "#00951465",
  "#00951466",
  "#00951467",
  "#00951468",
  "#00951469",
  "#0095146A",
  "#0095146B",
  "#0095146C",
  "#0095146D",
  "#0095146E",
  "#0095146F",
  "#00951470",
  "#00951471",
  "#00951472",
  "#00951473",
  "#00951474",
  "#00951475",
  "#00951476",
  "#00951477",
  "#00951478",
  "#00951479",
  "#0095147A",
  "#0095147B",
  "#0095147C",
  "#0095147D",
  "#0095147E",
  "#0095147F",
  "#00951480",
  "#00951481",
  "#00951482",
  "#00951483",
  "#00951484",
  "#00951485",
  "#00951486",
  "#00951487",
  "#00951488",
  "#00951489",
  "#0095148A",
  "#0095148B",
  "#0095148C",
  "#0095148D",
  "#0095148E",
  "#0095148F",
  "#00951490",
  "#00951491",
  "#00951492",
  "#00951493",
  "#00951494",
  "#00951495",
  "#00951496",
  "#00951497",
  "#00951498",
  "#00951499",
  "#0095149A",
  "#0095149B",
  "#0095149C",
  "#0095149D",
  "#0095149E",
  "#0095149F",
  "#009514A0",
  "#009514A1",
  "#009514A2",
  "#009514A3",
  "#009514A4",
  "#009514A5",
  "#009514A6",
  "#009514A7",
  "#009514A8",
  "#009514A9",
  "#009514AA",
  "#009514AB",
  "#009514AC",
  "#009514AD",
  "#009514AE",
  "#009514AF",
  "#009514B0",
  "#009514B1",
  "#009514B2",
  "#009514B3",
  "#009514B4",
  "#009514B5",
  "#009514B6",
  "#009514B7",
  "#009514B8",
  "#009514B9",
  "#009514BA",
  "#009514BB",
  "#009514BC",
  "#009514BD",
  "#009514BE",
  "#009514BF",
  "#009514C0",
  "#009514C1",
  "#009514C2",
  "#009514C3",
  "#009514C4",
  "#009514C5",
  "#009514C6",
  "#009514C7",
];

export const macroKeys = [
  "#00951500",
  "#00951501",
  "#00951502",
  "#00951503",
  "#00951504",
  "#00951505",
  "#00951506",
  "#00951507",
  "#00951508",
  "#00951509",
  "#0095150A",
  "#0095150B",
  "#0095150C",
  "#0095150D",
  "#0095150E",
  "#0095150F",
  "#00951510",
  "#00951511",
  "#00951512",
  "#00951513",
  "#00951514",
  "#00951515",
  "#00951516",
  "#00951517",
  "#00951518",
  "#00951519",
  "#0095151A",
  "#0095151B",
  "#0095151C",
  "#0095151D",
  "#0095151E",
  "#0095151F",
];

export const codeKeys = {
  "↓KeyA": "#11070004",
  "↑KeyA": "#10070004",
  "↓KeyB": "#11070005",
  "↑KeyB": "#10070005",
  "↓KeyC": "#11070006",
  "↑KeyC": "#10070006",
  "↓KeyD": "#11070007",
  "↑KeyD": "#10070007",
  "↓KeyE": "#11070008",
  "↑KeyE": "#10070008",
  "↓KeyF": "#11070009",
  "↑KeyF": "#10070009",
  "↓KeyG": "#1107000A",
  "↑KeyG": "#1007000A",
  "↓KeyH": "#1107000B",
  "↑KeyH": "#1007000B",
  "↓KeyI": "#1107000C",
  "↑KeyI": "#1007000C",
  "↓KeyJ": "#1107000D",
  "↑KeyJ": "#1007000D",
  "↓KeyK": "#1107000E",
  "↑KeyK": "#1007000E",
  "↓KeyL": "#1107000F",
  "↑KeyL": "#1007000F",
  "↓KeyM": "#11070010",
  "↑KeyM": "#10070010",
  "↓KeyN": "#11070011",
  "↑KeyN": "#10070011",
  "↓KeyO": "#11070012",
  "↑KeyO": "#10070012",
  "↓KeyP": "#11070013",
  "↑KeyP": "#10070013",
  "↓KeyQ": "#11070014",
  "↑KeyQ": "#10070014",
  "↓KeyR": "#11070015",
  "↑KeyR": "#10070015",
  "↓KeyS": "#11070016",
  "↑KeyS": "#10070016",
  "↓KeyT": "#11070017",
  "↑KeyT": "#10070017",
  "↓KeyU": "#11070018",
  "↑KeyU": "#10070018",
  "↓KeyV": "#11070019",
  "↑KeyV": "#10070019",
  "↓KeyW": "#1107001A",
  "↑KeyW": "#1007001A",
  "↓KeyX": "#1107001B",
  "↑KeyX": "#1007001B",
  "↓KeyY": "#1107001C",
  "↑KeyY": "#1007001C",
  "↓KeyZ": "#1107001D",
  "↑KeyZ": "#1007001D",
  "↓Digit1": "#1107001E",
  "↑Digit1": "#1007001E",
  "↓Digit2": "#1107001F",
  "↑Digit2": "#1007001F",
  "↓Digit3": "#11070020",
  "↑Digit3": "#10070020",
  "↓Digit4": "#11070021",
  "↑Digit4": "#10070021",
  "↓Digit5": "#11070022",
  "↑Digit5": "#10070022",
  "↓Digit6": "#11070023",
  "↑Digit6": "#10070023",
  "↓Digit7": "#11070024",
  "↑Digit7": "#10070024",
  "↓Digit8": "#11070025",
  "↑Digit8": "#10070025",
  "↓Digit9": "#11070026",
  "↑Digit9": "#10070026",
  "↓Digit0": "#11070027",
  "↑Digit0": "#10070027",
  "↓Enter": "#11070028",
  "↑Enter": "#10070028",
  "↓Escape": "#11070029",
  "↑Escape": "#10070029",
  "↓Backspace": "#1107002A",
  "↑Backspace": "#1007002A",
  "↓Tab": "#1107002B",
  "↑Tab": "#1007002B",
  "↓Space": "#1107002C",
  "↑Space": "#1007002C",
  "↓Minus": "#1107002D",
  "↑Minus": "#1007002D",
  "↓Equal": "#1107002E",
  "↑Equal": "#1007002E",
  "↓BracketLeft": "#1107002F",
  "↑BracketLeft": "#1007002F",
  "↓BracketRight": "#11070030",
  "↑BracketRight": "#10070030",
  "↓Backslash": "#11070031",
  "↑Backslash": "#10070031",
  "↓Semicolon": "#11070033",
  "↑Semicolon": "#10070033",
  "↓Quote": "#11070034",
  "↑Quote": "#10070034",
  "↓Backquote": "#11070035",
  "↑Backquote": "#10070035",
  "↓Comma": "#11070036",
  "↑Comma": "#10070036",
  "↓Period": "#11070037",
  "↑Period": "#10070037",
  "↓Slash": "#11070038",
  "↑Slash": "#10070038",
  "↓CapsLock": "#11070039",
  "↑CapsLock": "#10070039",
  "↓F1": "#1107003A",
  "↑F1": "#1007003A",
  "↓F2": "#1107003B",
  "↑F2": "#1007003B",
  "↓F3": "#1107003C",
  "↑F3": "#1007003C",
  "↓F4": "#1107003D",
  "↑F4": "#1007003D",
  "↓F5": "#1107003E",
  "↑F5": "#1007003E",
  "↓F6": "#1107003F",
  "↑F6": "#1007003F",
  "↓F7": "#11070040",
  "↑F7": "#10070040",
  "↓F8": "#11070041",
  "↑F8": "#10070041",
  "↓F9": "#11070042",
  "↑F9": "#10070042",
  "↓F10": "#11070043",
  "↑F10": "#10070043",
  "↓F11": "#11070044",
  "↑F11": "#10070044",
  "↓F12": "#11070045",
  "↑F12": "#10070045",
  "↓PrintScreen": "#11070046",
  "↑PrintScreen": "#10070046",
  "↓ScrollLock": "#11070047",
  "↑ScrollLock": "#10070047",
  "↓Pause": "#11070048",
  "↑Pause": "#10070048",
  "↓Insert": "#11070049",
  "↑Insert": "#10070049",
  "↓Home": "#1107004A",
  "↑Home": "#1007004A",
  "↓PageUp": "#1107004B",
  "↑PageUp": "#1007004B",
  "↓Delete": "#1107004C",
  "↑Delete": "#1007004C",
  "↓End": "#1107004D",
  "↑End": "#1007004D",
  "↓PageDown": "#1107004E",
  "↑PageDown": "#1007004E",
  "↓ArrowRight": "#1107004F",
  "↑ArrowRight": "#1007004F",
  "↓ArrowLeft": "#11070050",
  "↑ArrowLeft": "#10070050",
  "↓ArrowDown": "#11070051",
  "↑ArrowDown": "#10070051",
  "↓ArrowUp": "#11070052",
  "↑ArrowUp": "#10070052",
  "↓NumLock": "#11070053",
  "↑NumLock": "#10070053",
  "↓NumpadDivide": "#11070054",
  "↑NumpadDivide": "#10070054",
  "↓NumpadMultiply": "#11070055",
  "↑NumpadMultiply": "#10070055",
  "↓NumpadSubtract": "#11070056",
  "↑NumpadSubtract": "#10070056",
  "↓NumpadAdd": "#11070057",
  "↑NumpadAdd": "#10070057",
  "↓NumpadEnter": "#11070058",
  "↑NumpadEnter": "#10070058",
  "↓Numpad1": "#11070059",
  "↑Numpad1": "#10070059",
  "↓Numpad2": "#1107005A",
  "↑Numpad2": "#1007005A",
  "↓Numpad3": "#1107005B",
  "↑Numpad3": "#1007005B",
  "↓Numpad4": "#1107005C",
  "↑Numpad4": "#1007005C",
  "↓Numpad5": "#1107005D",
  "↑Numpad5": "#1007005D",
  "↓Numpad6": "#1107005E",
  "↑Numpad6": "#1007005E",
  "↓Numpad7": "#1107005F",
  "↑Numpad7": "#1007005F",
  "↓Numpad8": "#11070060",
  "↑Numpad8": "#10070060",
  "↓Numpad9": "#11070061",
  "↑Numpad9": "#10070061",
  "↓Numpad0": "#11070062",
  "↑Numpad0": "#10070062",
  "↓NumpadDecimal": "#11070063",
  "↑NumpadDecimal": "#10070063",
  "↓Menu": "#11070065",
  "↑Menu": "#10070065",
  "↓ControlLeft": "#110700E0",
  "↑ControlLeft": "#100700E0",
  "↓ShiftLeft": "#110700E1",
  "↑ShiftLeft": "#100700E1",
  "↓AltLeft": "#110700E2",
  "↑AltLeft": "#100700E2",
  "↓MetaLeft": "#110700E3",
  "↑MetaLeft": "#100700E3",
  "↓ControlRight": "#110700E4",
  "↑ControlRight": "#100700E4",
  "↓ShiftRight": "#110700E5",
  "↑ShiftRight": "#100700E5",
  "↓AltRight": "#110700E6",
  "↑AltRight": "#100700E6",
  "↓MetaRight": "#110700E7",
  "↑MetaRight": "#100700E7",
};
